module.exports = __webpack_public_path__ + "img/2020_20200119_163249.1a48f626.jpg";